module.exports = __webpack_public_path__ + "static/media/heart1.878c1e23.svg";